import { TableColumnsType, Tag, Typography } from "antd";
import dayjs from "dayjs";

import { Invoice } from "../../bitmaker/schemas/Billing/Invoice";
import { formatCurrency } from "../../utils";
import {
  getDaysDue,
  getDisplayStatus,
  getInvoiceClientDisplayName,
  getStatusColor,
} from "../../utils/billing";

const { Text } = Typography;

type InvoiceColumnsConfig = {
  showClient?: boolean;
};

export function getInvoiceColumns(
  config?: InvoiceColumnsConfig,
): TableColumnsType<Invoice> {
  const { showClient = true } = config || {};

  const clientColumn: TableColumnsType<Invoice>[number] = {
    title: "Client / Invoice Number",
    key: "client",
    render: (_, record) => (
      <div>
        <Text strong>{getInvoiceClientDisplayName(record)}</Text>
        <br />
        <Text type="secondary">{record.invoiceNumber}</Text>
      </div>
    ),
  };

  const invoiceNumberColumn: TableColumnsType<Invoice>[number] = {
    title: "Invoice Number",
    key: "invoiceNumber",
    render: (_, record) => <Text strong>{record.invoiceNumber}</Text>,
  };

  const baseColumns: TableColumnsType<Invoice> = [
    {
      title: "Description",
      key: "description",
      render: (_, record) => (
        <Text ellipsis>
          {record.items?.[0]?.itemDescription || "No description provided"}
        </Text>
      ),
    },
    {
      title: "Issued / Due Date",
      key: "dates",
      render: (_, record) => (
        <div>
          <Text>{dayjs(record.issueDate).format("YYYY-MM-DD")}</Text>
          <br />
          <Text type="secondary">{getDaysDue(record.dueDate)}</Text>
        </div>
      ),
    },
    {
      title: "Amount / Status",
      key: "amountStatus",
      render: (_, record) => {
        const status = getDisplayStatus(record);

        return (
          <div>
            <Text strong>
              {formatCurrency(
                Number(record.totalAmount) || 0,
                record.currency,
                record.language,
              )}
            </Text>
            <br />
            <Tag color={getStatusColor(status)} style={{ marginTop: 4 }}>
              {status.toUpperCase()}
            </Tag>
          </div>
        );
      },
    },
  ];

  return showClient
    ? [clientColumn, ...baseColumns]
    : [invoiceNumberColumn, ...baseColumns];
}
